import Button from '../../../components/base/Button';
import Card from '../../../components/base/Card';

export default function HeroSection() {
  const segments = [
    {
      title: 'Indústria de Alimentos',
      icon: 'ri-restaurant-line'
    },
    {
      title: 'Produtos Farmacêuticos',
      icon: 'ri-capsule-line'
    },
    {
      title: 'Ambientes Controlados',
      icon: 'ri-test-tube-line'
    },
    {
      title: 'Produtos Veterinários',
      icon: 'ri-heart-pulse-line'
    }
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/9fe66e1435b14f43ac70f1823ff5f75a.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-crop-white/95 via-crop-white/90 to-crop-white/70"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[80vh]">
          <div className="animate-fade-in">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-gilroy font-bold text-crop-black leading-tight mb-6">
              Identificação molecular que se adapta à sua necessidade
            </h1>
            <p className="text-xl md:text-2xl font-gilroy text-crop-dark mb-8 leading-relaxed">
              Três níveis de análise — Barcode<span className="trademark">®</span>, Barcode<span className="trademark">®</span> Pro e Barcode<span className="trademark">®</span> Meta
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="https://www.crop-labs.com" target="_blank" rel="noopener noreferrer">
                <Button size="lg" variant="outline" className="animate-slide-up whitespace-nowrap">
                  Voltar à Home
                </Button>
              </a>
              <a href="#contato">
                <Button size="lg" className="animate-slide-up whitespace-nowrap">
                  Solicitar Orçamento
                </Button>
              </a>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4 animate-fade-in">
            <div className="col-span-2 text-center mb-6">
              <h3 className="text-2xl font-gilroy font-semibold text-crop-black">
                Detecte e identifique microrganismos em:
              </h3>
            </div>
            {segments.map((segment, index) => (
              <Card key={index} hover className="group text-center">
                <div className="w-12 h-12 mx-auto bg-crop-teal/20 rounded-full flex items-center justify-center mb-4 group-hover:bg-crop-teal/30 transition-colors">
                  <i className={`${segment.icon} text-2xl text-crop-black`}></i>
                </div>
                <h3 className="text-lg font-gilroy font-bold text-crop-black">
                  {segment.title}
                </h3>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
